// src/data/staticEvent.ts
//
// Single source of truth for the static event data loaded from eventData.json.
// Import from here — never import staticEvent from EventLandingPage.tsx.
//
// Usage:
//   import { staticEvent } from "../../data/staticEvent";

import type { EventData } from "../types/eventTypes";
import rawEventData from "./eventData.json";

export type StaticEventData = EventData & { galleryImages?: string[] };

export const staticEvent: StaticEventData =
  rawEventData as unknown as StaticEventData;